export const ADMIN_PASSWORD = 'maia2026'
export const AUTH_KEY = 'maia_admin_auth'
